import icon from '@material-ui/icons/AddCircle';
import create from './ExtraCreate';
//import list from './SamplesList';
//import show from './SamplesView';
//import edit from './SamplesEdit';



export default{ 
    create,
    //list,
    //show, 
   // edit,
    icon
};